import { render, staticRenderFns } from "./ListOrdersComponent.vue?vue&type=template&id=954cba62"
import script from "./ListOrdersComponent.vue?vue&type=script&lang=js"
export * from "./ListOrdersComponent.vue?vue&type=script&lang=js"
import style0 from "./ListOrdersComponent.vue?vue&type=style&index=0&id=954cba62&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports